// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__351jI","containerItemsCenter":"Skeleton_containerItemsCenter__CcKQG"};